var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:['contact-header', !_setup.isBiggerThanTabletLandscape && 'tablet']},[_c('div',{staticClass:"contact-header-text"},[_c('h1',[_vm._v(_vm._s(_setup.__('Contact Padlet')))]),_vm._v(" "),_c('p',{domProps:{"innerHTML":_vm._s(_setup.subheading)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }